import React from 'react';
import { Grid } from '@mui/material';

import { DateField, ModuleSearchField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function CoursesDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TITLE */}
				<SimpleTextField
					name="crss_title"
					label={t('DETAILS_COURSES_FIELD_TITLE')}
					value={props.model.crss_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="crss_d_start"
					label={t('DETAILS_COURSES_FIELD_DATE_START')}
					value={props.model.crss_d_start}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="crss_d_end"
					label={t('DETAILS_COURSES_FIELD_DATE_END')}
					value={props.model.crss_d_end}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* SKILL */}
				<ModuleSearchField
					name="crss_skll_uid"
					label={t('DETAILS_COURSES_FIELD_SKILL')}
					module="skills"
					uid={props.model.crss_skll_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
